export class BrowserStorageHelper {
    static killSession(): void {
        window.localStorage.clear();
    }
}
